import React, { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useLogin } from "../context/LoginContext";
import TitleBox from "../components/common/TitleBox";
import ContainerBox from "../components/common/ContainerBox";
import NotificationForm from "../components/forms/NotificationForm";

const NotificacionesPage = () => {
  const navigate = useNavigate();
  const { user } = useLogin();

  useEffect(() => {
    if (user !== null) {
      navigate("/notificaciones");
    }
  }, [user]);

  return (
    <div className="pb-5">
      <TitleBox title="Notificaciones virtuales" />
      <ContainerBox>
        <NotificationForm />
      </ContainerBox>
    </div>
  );
};

export default NotificacionesPage;
